import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit, HostListener } from '@angular/core';
import { Settings } from 'common/core/config/settings.service';
import { Subscription } from 'rxjs';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { icons } from './icons';
import { faUserLock, faShippingFast, faDollarSign, faDownload, faTrafficLight, faShareAlt, faSave, faCloudUploadAlt } from '@fortawesome/free-solid-svg-icons';
declare var VANTA;

@Component({
    selector: 'homepage',
    templateUrl: './homepage.component.html',
    styleUrls: ['./homepage.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomepageComponent implements OnInit, OnDestroy {
    private sub: Subscription;

    /**@ViewChild('totalDownloads', { static: false }) totalDownloads: ElementRef
    @ViewChild('totalTraffic', { static: false }) totalTraffic: ElementRef*/

    faUserLock = faUserLock
    faShippingFast = faShippingFast
    faDollarSign = faDollarSign
    faDownload = faDownload
    faTrafficLight = faTrafficLight
    faShareAlt = faShareAlt
    faSave = faSave
    faCloudUploadAlt = faCloudUploadAlt

    constructor(
        public settings: Settings,
        private changeDetection: ChangeDetectorRef,
        protected library: FaIconLibrary
    ) {
        this.library.addIcons(...icons)
    }

    ngOnInit() {
        this.sub = this.settings.onChange.subscribe(() => {
            this.changeDetection.detectChanges();
        });

        VANTA.GLOBE({
            el: ".bg-container",
            mouseControls: true,
            touchControls: true,
            minHeight: 200.00,
            minWidth: 200.00,
            scale: 1.00,
            scaleMobile: 1.00,
            color: 0xff6435,
            backgroundColor: 0x161921,
            size: 0.9
        })
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    /**@HostListener('window:scroll', ['$event'])
    onScroll(event) {
        if (window.scrollY >= this.totalDownloads.nativeElement.getBoundingClientRect().top + this.totalDownloads.nativeElement.scrollHeight) {
            this.animateCount(this.totalDownloads, 999)
            this.animateCount(this.totalTraffic, 999, 'TB')
        }
    }**/

    public backgroundStyle() {
        const base = 'url(',
            end = ')',
            url = this.settings.get('landingPage.background');

        return base + this.settings.getBaseUrl(true) + url + end;
    }

    /**private animateCount(el: ElementRef, count: number, prefix?: string) {
        let counter = 0

        if (el.nativeElement.innerHTML.length != 0) {
            return
        }

        const interval = setInterval(() => {
            if (counter <= count) {
                el.nativeElement.innerHTML = prefix ? counter + ` ${prefix}` : counter
                counter++
            } else {
                clearInterval(interval)
            }
        }, count / (count * (1/5)))
    }**/
}
